import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './transparencia.css';
import { transparencia_item } from '../../json/transparenciaItem';

const Transparencia = ({name, data}) => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <div className='container transparencia-container container-mh'>
        <div className='row'>
            <div className='col-12'>
                <h1 className='title'>Transparencia</h1>
                <hr className='hr-gob'/>
            </div>
        </div>
        <div className='row'>
            {
 

                transparencia_item.map((item, index)=>(
                    <div key={ index } className='col-md-4 col-sm-6 col-12 transparencia_item'>
                        <Link to={ item.transparencia_item_url }>
                        <div >
                                    <a class="text-decoration-none"  >
                                        <button class="css-02a1-0 btn btn-outline-primary" tabindex="0" type="button">
                                            <div class="css-02b">
                                            <i class="fa-file-circle-info" aria-hidden="true"></i>
                                            
                                          
                                            </div><p class="css-02text text-wrap text-bk">{ item.transparencia_item_nombre }</p>
                                        </button>
                                    </a>
                                </div>
                        
                        </Link>
                    </div>
                ))
            }
        </div>
    </div>
  )
}

export default Transparencia